import Modal from "react-responsive-modal";
import { Activity } from "../../types";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { api } from "../services/api";
import Icon from "@mdi/react";
import { mdiImage } from "@mdi/js";
import { toBase64 } from "../services/common";
import { FileIcon, InputDate } from ".";

type EditActivityProps = {
    value: null | Activity;
    onChange: (value: Activity) => void;
    onClose: () => void;
};

export const emptyActivity: Activity = {
    _id: "",
    title: "",
    date: moment().format("YYYY-MM-DD"),
    text: "",
    file: { type: "EASY_DB_FILE", url: "" },
    archive: false,
};

export default function EditActivity({ value, onChange, onClose }: EditActivityProps) {
    const [activityActivity, setActivityActivity] = useState<Activity>(value ?? emptyActivity);
    const [message, setMessage] = useState("");

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setActivityActivity(value ?? emptyActivity);
        setMessage("");
    }, [value]);

    async function handleSave() {
        if (!activityActivity.title) {
            setMessage("Vyplň aspoň nadpis!");
            return;
        }
        if (!activityActivity.file.url) {
            setMessage("Nutné přidat soubor!");
            return;
        }

        setMessage("Ukládám...");

        if (activityActivity._id === "") {
            const [, error] = await api.addActivity(activityActivity);
            if (error) {
                setMessage("Přidání selhalo");
                return;
            }
            setMessage("Informace z činnosti přidána.");
        } else {
            const [, error] = await api.updateActivity(activityActivity);
            if (error) {
                setMessage("Ukládání změn selhalo");
                return;
            }
            setMessage("Informace z činnosti úspěšně uložena");
        }

        onChange(activityActivity);
    }

    return (
        <Modal
            open={value !== null}
            onClose={onClose}
            center
            styles={{ modal: { width: "550px" } }}
        >
            <h2>
                {activityActivity._id === "" ? "Přidat informaci z činnosti" : "Upravit informaci z činnosti"}
            </h2>
            {message && <p className="alert">{message}</p>}
            {value && <>
                <input
                    type="text"
                    placeholder="Napis"
                    value={activityActivity.title}
                    onChange={(e) => setActivityActivity({ ...activityActivity, title: e.target.value })}
                />

                <InputDate
                    value={activityActivity.date}
                    onChange={(date) => setActivityActivity({ ...activityActivity, date })}
                />

                <label>
                    <input
                        type="checkbox"
                        checked={activityActivity.archive}
                        onChange={(e) => setActivityActivity({ ...activityActivity, archive: e.target.checked })}
                    />
                    Archiv
                </label>

                <div style={{ textAlign: "center" }}>
                    {!activityActivity.file.url && <p>Není nahraný žádný soubor</p>}
                    {activityActivity.file.url && <FileIcon url={activityActivity.file.url} />}
                </div>
                <button onClick={() => inputRef.current?.click()} style={{ width: "100%", marginBottom: "20px" }}>
                    <Icon path={mdiImage} size={1} /> Přiložit soubor
                </button>
                <input
                    className="hidden"
                    ref={inputRef}
                    type="file"
                    onChange={async (e) => {
                        const file = e.target.files?.[0] as File;
                        if (!file) return;

                        const url = await toBase64(file);

                        setActivityActivity({ ...activityActivity, file: { type: "EASY_DB_FILE", url } });
                    }}
                />

                <textarea
                    style={{ minHeight: "250px" }}
                    placeholder="Krátký popis"
                    onChange={(e) =>
                        setActivityActivity({ ...activityActivity, text: e.target.value })}
                >
                    {activityActivity.text}
                </textarea>

                <button onClick={handleSave}>
                    {activityActivity._id === ""
                        ? "Přidat"
                        : "Uložit změny"}
                </button>
            </>}
        </Modal>
    );
}
